import User from "@/services/user";

const state = {
    user: {},
    userService: null
};

const getters = {
    user: state => state.user,
    userService: state => new User(state.user),

    isStockRoomUser: state => ['stockUser', 'stockManager'].includes(state.user.role.tag),
    isInHouseTechnician: state => state.user.technician && state.user.technician.in_house,
    isAreaManager: state => state.user.role.tag === 'areaManager',
    isSuperAdmin: state => state.user.role.tag === 'superAdmin',
    isTechnician: state => state.user.role.tag === 'technician',
    isJobManager(state) {
        return (
            state.user.role.tag === 'areaManager' ||
            state.user.role.tag === 'superAdmin'
        );
    },
    isDoppelganger(state) {
        if (state.user.role.tag !== 'technician') {
            return false;
        }

        if (!state.user.technician || !state.user.technician.technician) {
            return false;
        }

        return (state.user.name !== state.user.technician.technician);
    }
};

const actions = {
    fetchUser({commit}, {email, password}) {
        return new Promise((resolve, reject) => {
            this.$axios.post(
                '/api/admin-app/login',
                {
                    'email' : email,
                    'password' : password
                })
                .then(response => {

                    let user = response.data.data;

                    // Firestore access is minted from this key and has no
                    // fallback, so an account without one would sign in here and
                    // then be refused by every read. Stop it at the door.
                    if (!user.api || !user.api.key) {
                        reject('Your account is missing an API key. Please contact Customer Support.');
                        return;
                    }

                    commit('SET_USER', user);
                    resolve();
                })
                .catch(errors => {
                    console.log(errors);
                    reject(errors.response.data.messages[0]);
                });
        });
    },

    refreshUser({commit}) {
        return new Promise((resolve, reject) => {
            this.$axios.get('/api/admin-app/login/user').then(response => {
                let user = response.data.data;

                // A refresh must never downgrade a working session. The V4
                // transformer returns an empty api object for an account with no
                // key, and committing that would silently cut off Firestore for
                // the rest of the session.
                if (!user.api || !user.api.key) {
                    reject('Your account is missing an API key. Please contact Customer Support.');
                    return;
                }

                commit('SET_USER', user);
                resolve();
            })
            .catch(errors => {
                reject(errors.response.data.messages[0]);
            });
        });
    },

    clearUser({commit}) {
        return new Promise((resolve) => {
            commit('CLEAR_USER');
            resolve();
        })
    }
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },

    CLEAR_USER(state) {
        state.user = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}